/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function useCommitFunction(fn, use, deps = []) {
    const { commitFunctions } = useBoundContext()
    const boundFn = useCallback(fn, deps)
    if (use) {
        commitFunctions.add(boundFn)
    } else {
        commitFunctions.delete(boundFn)
    }
}
